import { lazy } from 'react'
import lazyLoad from './LazyLoad'

// 其他
export const othersRouter = [
  // {
  //   element: lazyLoad(lazy(() => import('@/pages/others/download/index'))),
  //   path: '/',
  // },
  {
    element: lazyLoad(lazy(() => import('@/pages/others/CustomerService'))),
    path: '/customerService',
  },
  // {
  //   component: lazy(() => import('@/pages/others/customShare')),
  //   path: '/custom-share',
  // },
  // {
  //   component: lazy(() => import('@/pages/others/DownloadApp')),
  //   path: '/download-app',
  // },
  // {
  //   component: lazy(() => import('@/pages/others/DownloadMerchantApp')),
  //   path: '/download-merchant-app',
  // },
  // {
  //   component: lazy(() => import('@/pages/others/JoinCommunity')),
  //   path: '/join-community',
  // },
]